/* eslint-disable no-dupe-keys */
export default {
  role: {
    name: '角色',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '角色名',
      role_type: '类型',
      service_provider: '运营商',
      created_at: '创建时间',
      updated_at: '更新时间',
      status: '状态',
      admins: '成员',
      note: '备注',
      authorizations: '权限'
    },
    // 列表页字段（列控制使用，需要与列表页匹配）
    columns: {
      name: '角色名',
      role_type: '类型',
      service_provider_id: '运营商',
      admins: '成员(可访问)',
      authorizations: '权限',
      created_at: '创建时间',
      updated_at: '更新时间',
      status: '状态',
      note: '备注'
    },
    // Enum的属性
    role_types: {
      platform_admin: '平台管理员',
      station_admin: '站长',
      group_admin: '合作集团',
      shop_admin: '店员'
    },
    statuses: {
      enabled: '可用的',
      disabled: '已禁用'
    },
    // 分类
    categories: {
      station: '电站信息',
      finance: '财务信息',
      task: '任务工单',
      user: '用户信息',
      operation: '市场运营',
      system: '系统信息',
      third_party: '互联互通',
      report: '报表中心',
      service_provider: '运营商',
      shop: '商店',
      paking_lot: '车位管理'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询角色'
    },
    // 列表标签
    list_tabs: {
      all: '全部',
      enabled: '可用的',
      disabled: '已禁用'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      authorizations: '权限'
    }
  }
}
